import React from 'react';
import { connect } from 'react-redux';

import LoadingContainer from '../../components/loading-container';
import Header from '../../components/header';

const BookingContainer = (props) => {
  const { app, booking, children } = props;
  const isFetching = app.isFetching || booking.isFetching;

  return (
    <LoadingContainer isLoading={isFetching} dispatch={props.dispatch}>
      <Header>Prenota online <span>un tavolo</span></Header>
      {children}
    </LoadingContainer>
  );
};


const mapStateToProps = ({ app, booking, }) => ({ app, booking, });
export default connect(mapStateToProps)(BookingContainer);



// WEBPACK FOOTER //
// ./src/containers/booking/booking-container.js